export enum ProjectServiceSubTabs {
  USEFUL_CONTACTS = 'useful-contacts',
  COMMON_AREA = 'common-areas',
  NEWS = 'news',
}
